<template>
  <!-- upload控件 -->
  <div
    class="upload"
    v-show="isShow"
    :class="[ listType === 'text' ? 'textType' : 'notextType' ]"
  >
    <el-upload
      ref="uploadCommon"
      action="upload"
      :http-request="uploadRequest"
      :name="name"
      :isAlone="isAlone"
      :list-type="listType"
      :show-file-list="false"
      :file-list="fileList"
      :multiple="multiple"
      :limit="limit"
      :auto-upload="true"
      :disabled="disabled"
      :accept="accept"
      :drag="drag"
      :before-upload="beforeUploadHandler"
      :on-error="errorHandle"
      :on-exceed="exceedHandle"
      :class="{ drag: drag }"
      v-show="fileList.length < limit"
    >
      <!-- 已上传的文件个数 小于 限制上传的个数则不再显示上传组件 -->
      <div class="el-upload__image" v-if="!isTextType && (fileList.length < limit) ">
        <i style="position: absolute; margin: 0; left: 5px; top: 5px" class="el-icon-upload"></i>
        <span
          style="
            height: 80px;
            width: 80px;
            position: absolute;
            left: 0px;
            line-height:130px;
            color: #969799;
            font-size: 12px;
          "
        >添加图片</span>
      </div>
      <div class="el-upload__text" v-if="isTextType">
        <div>
          <i class="el-icon-upload"></i>
          <em>添加文件</em>
          <span>{{ fileList.length }}/{{ limit }}</span>
          <br />
          <span>单个文件不超过 {{ fileSize }}M</span>
        </div>
      </div>
      <div
        slot="tip"
        v-if="!isTextType"
        class="el-upload__tip"
        :style="cssVar"
        :title="fileTitle"
      >
        {{ fileTitle }}
      </div>
    </el-upload>
  </div>
</template>

<script>
export default {
  name: 'CoreUpload',
  data() {
    return {}
  },
  computed: {
    isShow() {
      const { showUploadBtnByLimit, fileList, isTextType } = this
      return (
        (showUploadBtnByLimit
          ? fileList.length < showUploadBtnByLimit
          : fileList.length < 30) || isTextType
      )
    },
    cssVar() {
      return {
        '--width': this.fileTitleWidth,
      }
    },
  },
  props: {
    isTextType: {
      type: Boolean,
      default: false,
    },
    drag: {
      type: Boolean,
      default: true,
    },
    accept: {
      type: String,
      default: '',
    },
    fileTitle: {
      type: String,
      default: '',
    },
    fileTitleWidth: { // 提示语宽度
      type: String,
      default: '145px',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    isAlone: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: 'file',
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    listType: {
      type: String,
      default: 'picture-card',
    },
    showUploadBtnByLimit: {
      type: Number,
      default: null,
    },
    fileSize: {
      type: [String, Number],
      default: '',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    beforeUpload: Function,
  },
  methods: {
    uploadRequest({ file }) {
      this.$emit('uploadRequest', file)
    },
    beforeUploadHandler(file) {
      return this.beforeUpload(file)
    },
    errorHandle(err) {
      this.$meit('errorHandle', err)
    },
    exceedHandle(files, fileList) {
      this.$emit('exceedHandle', files, fileList)
    },
    // eslint-disable-next-line vue/no-unused-properties
    clearFile() {
      this.$refs.uploadCommon.clearFiles()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
</style>
